import React from 'react';
import ModalPortal from './ModalPortal';

/**
 * Confirmation modal that lists rule tables using a feature or feature value.
 */
export default function DeleteUsageConfirmModal({
    isOpen,
    kind,
    name,
    usages = [],
    loading = false,
    error = null,
    onConfirm,
    onClose
}) {
    if (!isOpen) return null;

    const isValue = kind === 'value';
    const title = isValue ? 'Delete Value' : 'Delete Feature';
    const itemLabel = isValue ? 'value' : 'feature';

    return (
        <ModalPortal>
        <div
            className="modal-overlay fade-in"
            onMouseDown={(e) => {
                if (e.target === e.currentTarget) onClose();
            }}
        >
            <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
                style={{
                    maxWidth: '520px',
                    width: '100%',
                    padding: '1.25rem',
                    borderRadius: 'var(--radius)',
                    background: 'var(--bg-primary)',
                    border: '1px solid var(--border)',
                    boxShadow: '0 8px 30px rgba(0,0,0,0.3)'
                }}
            >
                <h2 style={{ color: 'var(--error)', marginTop: 0 }}>{title}</h2>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', lineHeight: 1.4, marginBottom: '1rem' }}>
                    Are you sure you want to delete {itemLabel} <strong>{name}</strong>?
                    {isValue
                        ? ' This will remove it from all matching rule cells and may leave some cells empty.'
                        : ' This will delete all its values, properties, and remove it from all rule tables.'}
                </p>

                <div
                    style={{
                        background: 'rgba(220, 38, 38, 0.08)',
                        borderLeft: '3px solid var(--error)',
                        padding: '0.75rem',
                        fontSize: '0.85rem',
                        color: 'var(--text-primary)',
                        lineHeight: 1.4,
                        marginBottom: '1rem',
                        maxHeight: '220px',
                        overflowY: 'auto'
                    }}
                >
                    {loading && (
                        <span style={{ color: 'var(--text-secondary)' }}>Looking up where this is used…</span>
                    )}
                    {!loading && error && (
                        <span style={{ color: 'var(--error)' }}>{error}</span>
                    )}
                    {!loading && !error && usages.length === 0 && (
                        <span style={{ color: 'var(--text-secondary)' }}>
                            This {itemLabel} is not used in any rule table.
                        </span>
                    )}
                    {!loading && !error && usages.length > 0 && (
                        <>
                            <strong>Used in:</strong>
                            <ul style={{ margin: '0.5rem 0 0', paddingLeft: '1.2rem' }}>
                                {usages.map((usage) => {
                                    const rowLabel = usage.rowCount === 1 ? '1 row' : `${usage.rowCount} rows`;
                                    const familyName = usage.familyName || 'Unmapped';
                                    return (
                                        <li key={`${usage.familyId || 'none'}-${usage.ruleSetId}`}>
                                            {familyName} — {usage.ruleSetName} ({rowLabel})
                                        </li>
                                    );
                                })}
                            </ul>
                        </>
                    )}
                </div>

                <div className="modal-actions" style={{ marginTop: '1.5rem' }}>
                    <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
                    <button
                        type="button"
                        className="btn-primary"
                        style={{ background: 'var(--error)', color: 'white', border: 'none' }}
                        disabled={loading}
                        onClick={onConfirm}
                    >
                        Confirm Delete
                    </button>
                </div>
            </div>
        </div>
        </ModalPortal>
    );
}
